import { useEffect, useRef } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";

// Renders a Google AdSense unit. Renders nothing until both the publisher client
// (env) and a slot id are configured, so empty placements never leave layout gaps.
export default function AdSlot({ slot, format = "auto", responsive = true, layout, layoutKey, className = "", style }) {
  const pushed = useRef(false);

  useEffect(() => {
    if (!CLIENT || !slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      /* adsbygoogle not ready yet — will retry on next mount */
    }
  }, [slot]);

  if (!CLIENT || !slot) return null;

  return (
    <div className={`ad-slot my-8 w-full flex justify-center overflow-hidden ${className}`} data-testid="ad-slot" aria-label="Advertisement">
      <ins
        className="adsbygoogle"
        style={style || { display: "block", width: "100%" }}
        data-ad-client={CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        {...(layout ? { "data-ad-layout": layout } : {})}
        {...(layoutKey ? { "data-ad-layout-key": layoutKey } : {})}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
    </div>
  );
}
